export default __webpack_public_path__ + "static/media/unordered-list.f96f91a5.svg";